export default __webpack_public_path__ + "static/media/fruit-480w.f75ef0b0.png";